import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/layout/Navigation';
import { Footer } from '@/components/layout/Footer';
import { ArrowLeft } from 'lucide-react';

export default function BarrierefreiheitPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen">
      <Navigation />
      <main className="pt-28 pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <Link to="/" className="inline-flex items-center text-sm text-muted-foreground hover:text-primary transition-colors mb-8">
              <ArrowLeft className="w-4 h-4 mr-1" />
              Zurück zur Startseite
            </Link>

            <h1 className="font-heading font-bold text-4xl sm:text-5xl text-foreground mb-12">
              Barrierefreiheit
            </h1>

            <div className="prose prose-lg max-w-none space-y-8 text-foreground">
              <p className="text-muted-foreground leading-relaxed">
                Die DSG Beteiligungs- und Verwaltungsgesellschaft mbH ist bemüht, ihre Website möglichst barrierefrei zugänglich zu machen und kontinuierlich zu verbessern.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Diese Erklärung zur Barrierefreiheit gilt für die Website:<br />
                <a href="https://battery-grid.io/" className="text-primary hover:underline">https://battery-grid.io/</a>
              </p>

              <section>
                <h2 className="font-heading font-semibold text-2xl text-foreground mb-4">Stand der Vereinbarkeit mit den Anforderungen</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Diese Website orientiert sich an den Anforderungen der Barrierefreie-Informationstechnik-Verordnung (BITV 2.0) sowie an den internationalen Richtlinien der Web Content Accessibility Guidelines (WCAG).
                </p>
                <p className="text-muted-foreground leading-relaxed mt-4">
                  Wir arbeiten kontinuierlich daran, die Barrierefreiheit unserer Website weiter zu verbessern. Derzeit bestehen noch vereinzelt Barrieren, die im Rahmen der laufenden Weiterentwicklung reduziert werden.
                </p>
              </section>

              <section>
                <h2 className="font-heading font-semibold text-2xl text-foreground mb-4">Maßnahmen zur Barrierefreiheit</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Zur Verbesserung der Zugänglichkeit wurden unter anderem folgende Maßnahmen umgesetzt:
                </p>
                <ul className="list-disc list-inside text-muted-foreground leading-relaxed mt-2 space-y-1">
                  <li>strukturierte Seiteninhalte und nachvollziehbare Navigationslogik</li>
                  <li>Bedienbarkeit über Tastatur (Tab-Navigation)</li>
                  <li>Alternativtexte für relevante Bilder</li>
                  <li>ausreichende Farbkontraste zur besseren Lesbarkeit</li>
                  <li>responsive Darstellung für unterschiedliche Endgeräte</li>
                </ul>
              </section>

              <section>
                <h2 className="font-heading font-semibold text-2xl text-foreground mb-4">Feedback und Kontakt</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Sollten Ihnen Barrieren auf unserer Website auffallen oder benötigen Sie Unterstützung beim Zugriff auf Inhalte, kontaktieren Sie uns gerne:
                </p>
                <p className="text-muted-foreground leading-relaxed mt-4">
                  DSG Beteiligungs- und Verwaltungsgesellschaft mbH
                </p>
                <p className="text-muted-foreground leading-relaxed mt-2">
                  E-Mail: info@battery-grid.io
                </p>
                <p className="text-muted-foreground leading-relaxed mt-2">
                  Telefon:<br />
                  +49 176 93127245<br />
                  +49 30 71047955
                </p>
              </section>

              <section>
                <h2 className="font-heading font-semibold text-2xl text-foreground mb-4">Aktualisierung dieser Erklärung</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Diese Erklärung wird regelmäßig überprüft und bei Bedarf aktualisiert.
                </p>
              </section>

              <p className="text-sm text-muted-foreground pt-8 border-t border-border">
                © 2026 DSG Beteiligungs- und Verwaltungsgesellschaft mbH — Design & Umsetzung: webionik
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
